import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { GetFormalOffersLatestOfferConfigurationResponse } from '@iwoca/lapi-client/edge';

type TLatestOfferConfiguration =
    | GetFormalOffersLatestOfferConfigurationResponse['data']['latest_offer_configuration']
    | undefined;

export const getLatestOfferConfiguration = ({
    latestOfferConfiguration,
    formalOffers
}: {
    latestOfferConfiguration: TLatestOfferConfiguration;
    formalOffers: TFormalOffer[];
}) => {
    const noOfferConfiguration = {
        previouslySelectedFormalOffer: null,
        previouslySelectedAmount: null
    };

    if (!latestOfferConfiguration) return noOfferConfiguration;

    if (latestOfferConfiguration.offer_id) {
        const previouslySelectedFormalOffer = formalOffers.find(
            (offer) => offer.offer_id === latestOfferConfiguration.offer_id
        );

        if (!previouslySelectedFormalOffer) return noOfferConfiguration;

        return {
            previouslySelectedFormalOffer,
            previouslySelectedAmount: latestOfferConfiguration.cash_amount
        };
    }

    return noOfferConfiguration;
};
